import React, { useEffect, useState } from 'react';
import { Clock, Package, Percent, ClipboardCheck } from 'lucide-react';
import { StatCard as KpiCard, StatusTag } from './page';
import { formatNumber } from '../../utils/format';
import { calculateAverageAuditTime } from '../../utils/timeUtils';

const TREND = {
    good: { tone: 'success', label: 'Bien' },
    warning: { tone: 'warning', label: 'Regular' },
    bad: { tone: 'danger', label: 'Bajo' }
};

// KPI tile: big value with a muted unit suffix and an optional status pill.
function StatCard({ title, value, suffix, trend, icon, tone = 'brand' }) {
    const t = trend ? TREND[trend] || TREND.bad : null;
    return (
        <KpiCard
            label={title}
            icon={icon}
            tone={t ? t.tone : tone}
            value={
                <>
                    {value}
                    {suffix && <span className="ml-1 text-sm font-medium text-surface-400 tracking-normal">{suffix}</span>}
                </>
            }
            trend={t && <StatusTag tone={t.tone}>{t.label}</StatusTag>}
        />
    );
}

export default function AnalyticsInfo({ storeChecks = [], specific }) {
    const [timeInStore, setTimeInStore] = useState(0);

    const lastCheck = storeChecks.length ? storeChecks[storeChecks.length - 1] : {};
    const activeProds = lastCheck?.products?.filter((p) => p?.isAvailable) || [];
    const totalProducts = lastCheck?.products?.length || 0;
    const distributionPercent = totalProducts > 0 ? ((activeProds?.length / totalProducts) * 100).toFixed(1) : 0;

    useEffect(() => {
        setTimeInStore(calculateAverageAuditTime(storeChecks));
    }, [storeChecks]);

    const getTimeTrend = () => {
        if (timeInStore <= 20) return 'good';
        if (timeInStore <= 30) return 'warning';
        return 'bad';
    };

    const getDistributionTrend = () => {
        if (distributionPercent >= 80) return 'good';
        if (distributionPercent >= 50) return 'warning';
        return 'bad';
    };

    return (
        <div className={`grid gap-4 grid-cols-2 ${specific ? 'sm:grid-cols-3' : 'sm:grid-cols-2 lg:grid-cols-4'}`}>
            <StatCard
                title={specific ? 'Tiempo en Piso' : 'Tiempo Promedio'}
                value={timeInStore.toFixed(0)}
                suffix="min"
                icon={<Clock />}
                trend={getTimeTrend()}
            />
            <StatCard
                title="Distribución Numérica"
                value={formatNumber(activeProds.length)}
                suffix={`/ ${formatNumber(totalProducts)}`}
                icon={<Package />}
                tone="info"
            />
            <StatCard title="Distribución (%)" value={distributionPercent} suffix="%" icon={<Percent />} trend={getDistributionTrend()} />
            {!specific && <StatCard title="Auditorías Realizadas" value={formatNumber(storeChecks.length || 0)} icon={<ClipboardCheck />} tone="violet" />}
        </div>
    );
}
